import styled from "styled-components";

export const Subtitle = styled.h2`
  font-size: ${({ theme }) => theme.fontSize.l};
  color: ${({ theme }) => theme.colors.dark};
  padding: 0 16px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
`;
